export enum PermissoesUsuarioEnum {
    ADMINISTRADOR = 'ROLE_ADMINISTRADOR',
    ASSESSOR = 'ROLE_ASSESSOR',
    ESCRITORIO = 'ROLE_ESCRITORIO',
    INVESTIDOR = 'ROLE_INVESTIDOR'
}
